import { sdk } from 'src/utilities/sdk';
import { IAsyncTaskResponse } from 'src/utilities/useAsyncTask';

export interface DeactivateMealCreditProps {
  corpId: string;
  mealCreditId: string;
}

export const deactivateMealCreditApi = async ({
  corpId,
  mealCreditId,
}: DeactivateMealCreditProps): Promise<IAsyncTaskResponse> => {
  return sdk.http.delete(`/corp-admin/${corpId}/events/${mealCreditId}`);
};
